import Marquee from "react-fast-marquee";
import { MARQUEE_VALUES } from "../data/content";

export const ValuesMarquee = () => {
  return (
    <section
      data-testid="marquee-values"
      className="bg-[#F4F2F7] border-y border-[#E8E4EE] py-6"
    >
      <Marquee gradient={false} speed={40}>
        {MARQUEE_VALUES.map((v, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif-display italic text-2xl text-[#2D1B4E] px-16">
              {v}
            </span>
            <span className="text-[#5B3E96]">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
